/* eslint-disable */

export const enum TemporaryAccessStatus {
  pending = 1,
  active = 2,
  revoked = 3,
  expired = 4,
}
